export interface BankCard {
  brand: string;
  last4: string;
  token: string;
  expirationDate: string;
  isDefault: boolean;
}

export enum WidgetStates {
  LIST = 'list',
  FORM = 'form',
  FETCHING = 'fetching',
  EMPTY_LIST = 'empty_list',
}

export interface CommonProps {
  isCheckout: boolean;
  paymentState: WidgetStates;
  setPaymentState: (state: WidgetStates) => void;
  onTokenReceived: (token: string) => any;
}

export interface PaymentRequest {
  amount: number;
  onTokenReceived: (token: string) => any;
}

export interface PaymentWidgetProps extends Pick<CommonProps, 'isCheckout'> {
  paymentRequest?: PaymentRequest;
}

export interface PaymentWidgetReturnType extends CommonProps {
  paymentRequest?: PaymentRequest;
  paymentMethods: BankCard[];
  generateCardToken: () => Promise<string | undefined> | undefined;
  paymentFormRef?: React.MutableRefObject<any>;
  activePaymentToken?: string;
}

export interface PaymentMethodsListProps extends Exclude<CommonProps, 'paymentState'> {
  paymentMethods: BankCard[];
  activePaymentToken?: string;
}

export interface PaymentMethodProps extends Pick<CommonProps, 'isCheckout'> {
  card: BankCard;
  isSelected: boolean;
  onSelect: (token: string) => any;
}
